import { NavLink, Navigate, useLocation } from "react-router-dom";
import s from "./Header.module.css";

const getClass = (isActive) => (isActive ? s.active : s.link);

const Header = () => {
    const location = useLocation();

    if (location.pathname === "/glb_scene/three")
        return <Navigate to={"/glb_scene/three/bathroom"} />;
    // navigate("/glb_scene/three/bathroom");

    return (
        <header className={s.header}>
            <nav className={s.nav}>
                <NavLink
                    to="/glb_scene/three/bathroom"
                    className={({ isActive }) => getClass(isActive)}
                >
                    Bathroom
                </NavLink>
                <NavLink
                    to="/glb_scene/three/bedroom"
                    className={({ isActive }) => getClass(isActive)}
                >
                    Bedroom
                </NavLink>
            </nav>
        </header>
    );
};

export default Header;
